<template>
    <div class="container">
        <van-button class="fast" @click.stop.prevent="onClick(1)">手机号一键登录</van-button>
        <van-button class="code" type="default" @click.stop.prevent="onClick(2)">手机号码登录</van-button>
    </div>
</template>

<script>
export default {
    methods: {
        onClick(index) {
            this.$emit('click', index);
        }
    }
};
</script>

<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .fast {
        margin-top: 50px;
        width: 295px;
        height: 44px;
        background: #596AFD;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 16px;
    }

    .code {
        margin-top: 20px;
        width: 295px;
        height: 44px;
        border-radius: 6px;
        border: 1px solid #E7E4E9;
        font-size: 16px;
    }
}
</style>